import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InvoiceStateService } from '../../state-and-data-handling/invoice-state.service';
import { findKvRecordValue } from '../../../../../../shared/functions/record-functions';
import { DueDateMetaKey, InvoiceDateMetaKey, TitleMetaKey } from '../../../invoice.config';
import { DateTimeHelper } from '../../../../../../features/calendar/util/date-time-helper';
import { assert } from '../../../../../../core/assert/assert';
import { FormControlNameRecord } from '../../../../../../shared/data-types/form-types';

@Component({
  selector: 'app-edit-document-section-base-data',
  templateUrl: './edit-document-section-base-data.component.html',
  standalone: false,
})
export class EditDocumentSectionBaseDataComponent implements OnInit {
  readonly baseDataForm = signal<FormGroup | null>(null);

  public formControlNames: FormControlNameRecord = {
    Title: 'title',
    DueDate: 'dueDate',
    InvoiceDate: 'invoiceDate',
  };

  // DI
  private readonly formBuilder = inject(FormBuilder);
  private readonly invoiceStateService = inject(InvoiceStateService);

  private readonly meta = computed(() => this.invoiceStateService.meta());

  ngOnInit(): void {
    this.buildForm();
  }

  public formValueChanged([value, formCtrlName]: [string | Date, string]): void {
    assert(typeof formCtrlName !== 'undefined', `Form control name is undefined: ${formCtrlName}`);
    if (DateTimeHelper.isValid(value)) {
      value = DateTimeHelper.format(value as Date);
    }

    const record: Record<string, string | Date> = { [formCtrlName]: value };
    this.invoiceStateService.updateMeta(record);
  }

  private buildForm(): void {
    const title = findKvRecordValue(this.meta(), TitleMetaKey);

    let dueDate = findKvRecordValue(this.meta(), DueDateMetaKey);
    dueDate = DateTimeHelper.parseISO(dueDate as string);

    let invoiceDate = findKvRecordValue(this.meta(), InvoiceDateMetaKey);
    invoiceDate = DateTimeHelper.parseISO(invoiceDate as string);

    this.baseDataForm.set(
      this.formBuilder.group({
        [this.formControlNames.Title]: [title],
        [this.formControlNames.DueDate]: [dueDate],
        [this.formControlNames.InvoiceDate]: [invoiceDate],
      }),
    );
  }
}
